<div>
  <div class="loading-spinner">
    <div [ngClass]="{'bounce1': true, 'light': light}"></div>
    <div [ngClass]="{'bounce2': true, 'light': light}"></div>
    <div [ngClass]="{'bounce3': true, 'light': light}"></div>
  </div>
</div>